import { render } from "./ChangePWView.vue?vue&type=template&id=65492db9&scoped=true"
import script from "./ChangePWView.vue?vue&type=script&lang=js"
export * from "./ChangePWView.vue?vue&type=script&lang=js"

import "./ChangePWView.vue?vue&type=style&index=0&id=65492db9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65492db9"]])

export default __exports__